import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Sun, Moon } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function Footer() {
  const { theme, toggle } = useTheme();
  return (
    <footer className="border-t" style={{ borderColor: 'var(--border)' }}>
      <div className="max-w-7xl mx-auto px-5 lg:px-8 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-2">
          <span className="logo-grad w-8 h-8 rounded-lg flex items-center justify-center text-white font-extrabold text-[13px] tracking-tight shadow-sm">TO</span>
          <span className="text-[15px] font-semibold tracking-tight">Studios</span>
        </Link>
        <div className="flex flex-wrap gap-6 text-sm" style={{ color: 'var(--text-muted)' }}>
          <a href="/#about" className="hover-link">Hakkımızda</a>
          <a href="/#team" className="hover-link">Ekip</a>
          <a href="/#games" className="hover-link">Oyunlar</a>
          <a href="/#stats" className="hover-link">İstatistik</a>
          <Link to="/wiki" className="hover-link">Wiki</Link>
        </div>
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <Sun size={14} style={{ color: theme === 'light' ? 'var(--text)' : 'var(--text-muted)' }} />
            <button onClick={toggle} aria-label="Toggle theme" className="theme-toggle">
              <span className="knob">{theme === 'dark' ? <Moon size={12} /> : <Sun size={12} />}</span>
            </button>
            <Moon size={14} style={{ color: theme === 'dark' ? 'var(--text)' : 'var(--text-muted)' }} />
          </div>
          <div className="text-xs" style={{ color: 'var(--text-muted)' }}>© {new Date().getFullYear()} TO Studios</div>
        </div>
      </div>
    </footer>
  );
}
